import { config } from 'depop/config';

export default class Mixpanel {
  constructor() {
    if (typeof window === 'undefined') {
      return;
    }

    if (__DEV__) {
      window.mixpanel = {
        identify(params) {
          console.groupCollapsed(`[Mixpanel] Identify`);
          console.debug(params);
          console.groupEnd();
        },
        track(name, params) {
          console.groupCollapsed(`[Mixpanel] Event: ${name}`);
          console.debug(params);
          console.groupEnd();
        },
        reset() {
          console.debug(`[Mixpanel] Reset`);
        },
      };
    }
    this.context = {
      user: {},
    };
  }

  identifyUser({ id, username }) {
    this.context = {
      ...this.context,
      user: {
        username,
        id,
      },
    };

    window.mixpanel.identify(id);
  }

  unidentifyUser() {
    window.mixpanel.reset();
    this.context = {
      ...this.context,
      user: {},
    };
  }

  trackLogin({ id, username }) {
    window.mixpanel.track('confirm signin', {
      $username: username,
    });
  }

  trackLogout() {
    window.mixpanel.track('signout');
  }

  trackBuyProduct({
    username,
    id,
    slug,
    price,
    currency,
    source,
    similarItemIndex,
  }) {
    window.mixpanel.track('buy product', {
      $username: this.context.user.username,
      id: this.context.user.id,
      'product owner': username,
      product: id,
      slug: slug,
      price: price,
      currency: currency,
      from: source,
      'similar item index': similarItemIndex,
    });
  }

  trackLikeProduct({
    username,
    id,
    slug,
    price,
    currency,
    source,
    similarItemIndex,
  }) {
    const isMine = this.context.user.username === username;

    window.mixpanel.track('like product', {
      $username: this.context.user.username,
      id: this.context.user.id,
      'product owner': username,
      product: id,
      slug: slug,
      price: price,
      currency: currency,
      isMine: isMine ? 'yes' : 'no',
      from: source,
      'similar item index': similarItemIndex,
    });
  }

  trackUnlikeProduct({
    username,
    id,
    slug,
    price,
    currency,
    source,
    similarItemIndex,
  }) {
    const isMine = this.context.user.username === username;

    window.mixpanel.track('unlike product', {
      $username: this.context.user.username,
      id: this.context.user.id,
      'product owner': username,
      product: id,
      slug: slug,
      price: price,
      currency: currency,
      isMine: isMine ? 'yes' : 'no',
      from: source,
      'similar item index': similarItemIndex,
    });
  }

  trackFollowUser({ username }) {
    window.mixpanel.track('follow user', {
      $username: this.context.user.username,
      id: this.context.user.id,
      by: this.context.user.username,
      to: username,
    });
  }

  trackUnfollowUser({ username }) {
    window.mixpanel.track('unfollow user', {
      $username: this.context.user.username,
      id: this.context.user.id,
      by: this.context.user.username,
      to: username,
    });
  }

  trackProductSearch({ query }) {
    window.mixpanel.track('execute products search', {
      $username: this.context.user.username,
      id: this.context.user.id,
      query: query,
    });
  }

  trackPasswordResetRequest({ identifier }) {
    window.mixpanel.track('request password reset', {
      identifier: identifier,
    });
  }

  trackEditShop() {
    window.mixpanel.track('edit shop', {
      $username: this.context.user.username,
    });
  }

  trackSaveEditShop() {
    window.mixpanel.track('save shop', {
      $username: this.context.user.username,
    });
  }

  trackCancelEditShop() {
    window.mixpanel.track('cancel edit shop', {
      $username: this.context.user.username,
    });
  }

  moveSoldItemsToBottom() {
    window.mixpanel.track('move sold items to bottom', {
      $username: this.context.user.username,
    });
  }

  trackBeginListingFlow() {
    window.mixpanel.track('add new product', {
      $username: this.context.user.username,
      id: this.context.user.id,
      country: null, // two-letter
      gender: null, // m/f/o
      sendNewsletter: 'no',
    });
  }

  trackConfirmListing() {
    window.mixpanel.track('confirm product creation', {
      $username: this.context.user.username,
      id: this.context.user.id,
      'category id': null, // number
      'category name': null, // string
      'category path': null, // string
      country: null, // two-letter
      facebook: 'no',
      gender: null, // m/f/o
      hand_delivery: 'no',
      images: null, // number
      instagram: 'no',
      location: null, // string
      national_shipping: null, // yes/no
      paypal: 'yes',
      price: null, // number
      quantity: null, // number,
      sendNewsletter: 'no',
      'size ids': [], // ["11"]
      'size names': [], // ["M"]
      twitter: 'no',
      'variant name': null, // wmns-tops-sizes
      'variant set id': null, // 1
      'variant uid': 2, // null,
      worldwide_shipping: null, // yes/no
    });
  }
}



// WEBPACK FOOTER //
// ../src/client/utils/tracking/Mixpanel.js